module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("T")]), _vm._v("he war had not yet touched Oswego, New York, in the spring of 1940. Young people like Joseph Spereno were focused on high school studies and teenage social life. The "), _c('i', [_vm._v("Oswego Palladium-Times")]), _vm._v(" of April 8, 1940, in fact, notes that young Joe Spereno was among those attending a surprise sixteenth birthday celebration for Miss Evelyn Houghton. An account of the party that took place at the John Street home of Mr. and Mrs. Francis L. Matott was featured on page 2 of the newspaper.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Hints of the war that was overwhelming Europe—and that would soon involve the United States—hovered like a dark cloud on page 2 as well. Headlines warned about the German and British armies tangling in the waters of the Adriatic Sea and along the Norwegian coast.")]), _c('a', {
    attrs: {
      "id": "isup2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Notes#sup2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" Still, the war was far from Joe Spereno’s door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the war was very much at young Jacob Fajnzylberg’s door. A member of the French army, Fajnzylberg was among the thousands of French, British and Belgian troops who, in just a few weeks, would be forced to retreat to the beaches of Dunkirk in the face of overpowering German Panzer attacks. He participated in the Battle of Dunkirk Beach, where the British army was trapped and where one of the most dramatic rescues of the war ultimately took place. But Fajnzylberg was not among those rescued at Dunkirk. Instead, within forty-eight hours, he was picked up by the German military and sent to an internment and deportation camp, the Royallieu-Compiègne, located in the north of France, where the prisoners included French resistance fighters and Jews. He was then transferred by train from "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("that camp to certain death at a gas chamber maintained by the Germans on the Belgium-France border. Not far from where that gas chamber was located, however, he managed to jump from a window of the train. Despite sustaining a back injury in the fall, he was able to make his way back to Paris. There, he reunited with his wife, Sarah, and their twelve-year-old son, Charles, and joined the Maquis, the French Underground, whose purpose it was to sabotage the Germans whenever and wherever possible.")]), _c('a', {
    attrs: {
      "id": "isup3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Notes#sup3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joseph Spereno and Jacob Fajnzylberg, two young men separated by geography, religion, language, culture and experience, would ultimately cross paths in a most unlikely place because of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On August 5, 1944, 982 refugees from the Nazi Holocaust were transported from war-torn Europe to Fort Ontario in Oswego, New York. They lived at the fort grounds until February 5, 1946. Established by order of President Franklin Roosevelt, the Fort Ontario Emergency Refugee Shelter was intended to convince American allies that the United States was serious about rescuing and providing relief to the Jews of Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it turned out, this was the only World War II shelter established in the United States to accept refugees fleeing Nazi persecution. In response, Oswego opened its door at a time when anti-Semitism was rampant in the country. It is a story that certainly resonates to this day, as the crisis of asylum seekers rages across the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once safe on American soil, these Holocaust refugees and the citizens of the community that opened its doors to them gradually began to interact. The stories of the refugees and the Oswegonians, people like Jacob Fajnzylberg and Joseph Spereno, and the impact they had on each other over the course of their lives, demonstrates how individuals can be enriched when the barriers of fear and distrust dissolve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Author Mariam Bat-Ami said that Oswego represented “all that is possible in a community, all that is open-hearted in ourselves, as long as we keep the door to our souls open.”"), _c('a', {
    attrs: {
      "id": "isup4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Notes#sup4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What follows is the story of the Oswegonians and the refugees who lived together in the singular open-hearted community that kept the door to its soul open.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc174572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 78
// module chunks = 0